import modelBaseV2 from '../model-base-v2.model';

let taskTodoModel = {

    getTaskNumbers: function (filter) {
        let urlParams = modelBaseV2.toQueryString({
          fromDate: filter.fromDate,
          toDate: filter.toDate,
          taskMstId: filter.selectedTaskListArr.join('^'),
          siteId: filter.selectedSites.map(e => e.code).join('^')
        });

        return modelBaseV2.get('/api/todo/typeandstatus?' + urlParams);
    },

    getSiteNumbers: function (filter) {
        let urlParams = modelBaseV2.toQueryString({
            fromDate: filter.fromDate,
            toDate: filter.toDate,
            taskMstId: filter.selectedTaskListArr.join('^'),
            siteId: filter.selectedSites.map(e => e.code).join('^')
        });

        return modelBaseV2.get('/api/todo/storestatus?' + urlParams);
    },

    getTaskList: function (filter) {
        let urlParams = modelBaseV2.toQueryString({
            fromDate: filter.fromDate,
            toDate: filter.toDate,
            PageIndex: filter.pageIndex,
            PageSize: filter.pageSize,
            taskMstId: filter.selectedTaskListArr.join('^'),
            siteId: filter.selectedSites.map(e => e.code).join('^'),
            filter: filter.filter
        });

        return modelBaseV2.get('/api/todo/task?' + urlParams);
    },

    getSiteList: function (filter) {
        let urlParams = modelBaseV2.toQueryString({
            fromDate: filter.fromDate,
            toDate: filter.toDate,
            PageIndex: filter.pageIndex,
            PageSize: filter.pageSize,
            taskMstId: filter.selectedTaskListArr.join('^'),
            siteId: filter.selectedSites.map(e => e.code).join('^'),
            filter: filter.filter
        });

        return modelBaseV2.get('/api/todo/site?' + urlParams);
    },

    getSiteDetail: function (filter) {
        let urlParams = modelBaseV2.toQueryString({
            fromDate: filter.fromDate,
            toDate: filter.toDate,
            PageIndex: filter.pageIndex,
            PageSize: filter.pageSize, 
            taskMstId: filter.taskList,
            siteId: filter.siteList,
            filter: filter.filter
        });
        
        return modelBaseV2.get('/api/todo/sitedetail?' + urlParams);
    },

    getTaskDetail: function (filter) {
        let urlParams = modelBaseV2.toQueryString({
            fromDate: filter.fromDate,
            toDate: filter.toDate,
            PageIndex: filter.pageIndex,
            PageSize: filter.pageSize, 
            taskMstId: filter.taskList,
            siteId: filter.siteList,
            filter: filter.filter
        });

        return modelBaseV2.get('/api/todo/taskdetail?' + urlParams);
    },

    downloadExcel: (filter, fileName, isTasks) => {
        let params = {
            sortBy: "",
            orderBy: "",
            pageIndex: 0,
            pageSize: 0,
            storedProcedureCode: isTasks ? "5" : "6",
            params: [
                { code: "8", value: filter.fromDate },
                { code: "9", value: filter.toDate }, 
                { code: "25", value: filter.selectedSites.map(e => e.code).join('^') }, 
                { code: "26", value: filter.selectedTaskListArr.join('^') },
                { code: "27", value: filter.filter }, 
                { code: "2", value: "" }, 
                { code: "3", value: "0" }, 
                { code: "4", value: "0" }
            ],
            excelSheetNames: ["To Do List", "To Do Count"]
        };
        
        return modelBaseV2.postDownload('/api/retail/file/export/tr/file', { body: params }, fileName + ".xlsx");
    },

    downloadExcelSite: (filter, fileName) => {
        let params = {
            sortBy: "",
            orderBy: "",
            pageIndex: 0,
            pageSize: 0,
            storedProcedureCode: "7",
            params: [
                { code: "8", value: filter.fromDate },
                { code: "9", value: filter.toDate }, 
                { code: "25", value: filter.siteList }, 
                { code: "26", value: filter.taskList },
                { code: "27", value: filter.filter }, 
                { code: "2", value: "" }, 
                { code: "3", value: "0" }, 
                { code: "4", value: "0" }
            ],
            excelSheetNames: ["To Do Site List", "To Do Count"]
        };

        return modelBaseV2.postDownload('/api/retail/file/export/tr/file', { body: params }, fileName + ".xlsx");
    },

    downloadExcelTask: (filter, fileName) => {
        let params = {
            sortBy: "",
            orderBy: "",
            pageIndex: 0,
            pageSize: 0,
            storedProcedureCode: "8",
            params: [
                { code: "8", value: filter.fromDate },
                { code: "9", value: filter.toDate }, 
                { code: "25", value: filter.siteList }, 
                { code: "26", value: filter.taskList },
                { code: "27", value: filter.filter }, 
                { code: "2", value: "" }, 
                { code: "3", value: "0" }, 
                { code: "4", value: "0" }
            ],
            excelSheetNames: ["To Do Task List", "To Do Count"]
        };

        return modelBaseV2.postDownload('/api/retail/file/export/tr/file', { body: params }, fileName + ".xlsx");
    },

}

export default taskTodoModel;
